import React from 'react';
import { Spin } from '@weapp/ui';

function Loading(props: any) {
  return (
    <Spin weId={`${props.weId || ''}_e427f5`}><div style={{ width: '100%', height: '100vh' }}></div></Spin>
  );
}

export default Loading;